<template>
  <button
    type="button"
    class="kds-add-witness-button"
    @click="$emit('click', $event)"
  >
    <KdsIcon name="plus" :size="18" />
    <span class="kds-add-witness-button__label">
      <slot>Add witness</slot>
    </span>
  </button>
</template>

<script setup lang="ts">
import KdsIcon from '@/kds/primitives/KdsIcon.vue';

defineEmits<{ click: [event: MouseEvent] }>();
</script>

<style scoped lang="scss">
.kds-add-witness-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  width: 100%;
  padding: var(--space-4);
  background: transparent;
  color: var(--stone);
  border: var(--bw) dashed var(--mist-2);
  border-radius: var(--r-3);
  font-family: var(--font-ui);
  font-size: var(--fs-body-sm);
  cursor: pointer;
  transition:
    color var(--d-fast) var(--ease-out),
    border-color var(--d-fast) var(--ease-out);

  &:hover {
    color: var(--ink);
    border-color: var(--ink);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
  }
}
</style>
